<ng-container *ngTemplateOutlet="readOnly ? readonlyContent : (groupOptions?.length > 0 ? editContent : noElements)">
</ng-container>

<!-- Template mode visu. -->
<ng-template #readonlyContent>
	<ng-container *ngIf="groupOptions?.length > 0; else noElements;">
		<ion-list mode="md" *ngIf="!sortGroupsByType; else groupsByType;">
			<ion-list-header mode="md" *ngIf="!hideTitle">
				<ion-label>{{ title }}</ion-label>
			</ion-list-header>
			<ion-item *ngFor="let groupOption of groupOptions; let idx = index"
				[lines]="idx + 1 === groupOptions.length ? 'none' : 'inset'"
				class="ion-no-padding pad-left-txt groups-list-visu">
				{{ groupOption.value.name }}
			</ion-item>
		</ion-list>

		<ng-template #groupsByType>
			<ion-list mode="md" *ngFor="let groupOptionsByType of groupsOptionsByTypes">
				<ion-list-header mode="md">
					<div>
						<ion-label>{{ groupOptionsByType.title }}</ion-label>
					</div>
					<div class="divider"></div>
				</ion-list-header>
				<ng-container *ngIf="groupOptionsByType.mode !== tagsDisplayMode; else tags;">
					<ion-item *ngFor="let groupOption of groupOptionsByType.groupOptions; let idx = index"
						[lines]="idx + 1 === groupOptionsByType.groupOptions.length ? 'none' : 'inset'"
						class="ion-no-padding pad-left-txt groups-list-visu" (click)="onItemClicked(groupOption.value)">
						{{ groupOption.value.name }}
					</ion-item>
				</ng-container>
				<ng-template #tags>
					<div class="tags-button">
						<ion-button *ngFor="let groupOption of groupOptionsByType.groupOptions" class="tag-btn" mode="ios"
							shape="round" color="primary">
							{{ groupOption.value.name }}
						</ion-button>
					</div>
				</ng-template>
			</ion-list>
		</ng-template>
	</ng-container>
</ng-template>

<!-- Template mode edit. -->
<ng-template #editContent>
	<ion-list *ngIf="!sortGroupsByType; else editGroupsByType;">
		<ion-list-header *ngIf="!hideTitle">
			<ion-label>{{ title }}</ion-label>
		</ion-list-header>
		<div class="groups-list" scrolly="true">
			<osapp-selector [options]="groupOptions" [preselectedValues]="preSelectedGroups" [multiple]="multiple"
				(selectionChanged)="onGroupSelectionChanged($event)" displayMode="list" [min]="min"></osapp-selector>
		</div>
	</ion-list>

	<ng-template #editGroupsByType>
		<ion-list *ngFor="let groupOptionsByType of groupsOptionsByTypes">
			<ng-container *ngIf="groupOptionsByType.title === 'Groupes' || groupOptionsByType.title === 'Profils'">
				<ion-list-header>
					<ion-label>{{ groupOptionsByType.title }}</ion-label>
				</ion-list-header>
				<div class="groups-list" scrolly="true">
					<osapp-selector [options]="groupOptionsByType.groupOptions" [preselectedValues]="preSelectedGroups"
						[multiple]="multiple" (selectionChanged)="onGroupSelectionChanged($event)" displayMode="list" [min]="min">
					</osapp-selector>
				</div>
			</ng-container>
		</ion-list>
	</ng-template>
</ng-template>

<!-- Template si aucun groupe. -->
<ng-template #noElements>
	<ion-label class="no-groups">{{emptyText}}</ion-label>
</ng-template>